import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { endPoints } from '../../Config';
import { handleGetRequest } from '../../service/GetTemplate';

const ViewRole = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [allPermissions, setAllPermissions] = useState(null);
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);

    const location = useLocation();
    const { rowData } = location.state || {};

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            id: '',
            roleName: ''
        }
    });

    const getAllPermissions = async () => {
        const response = await handleGetRequest(endPoints.getallPermissions, true, false, dispatch);
        if (response) {
            setAllPermissions(response?.data);
        }
    };

    const getRoleById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getRoleById(rowData.id), true);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('roleName', response?.data?.roleName);

            const selectedPermissions = response?.data?.permissions || [];

            const mappedPermissions = selectedPermissions
                .filter((item) => item.isAllowed === true)
                .map((item) => ({
                    modulePermissionId: item.permissionId,
                    isAllowed: true
                }));

            setSelectedPermissionIds(mappedPermissions);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        getAllPermissions();
    }, []);

    useEffect(() => {
        if (rowData) {
            getRoleById();
        }
    }, [rowData]);

    const handleCancel = () => {
        navigate('/roles-permissions');
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Edit Role</h3>
            </div>

            <form onSubmit={formik.handleSubmit}>
                <div className="grid p-fluid">
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="roleName">
                                Role Name <span style={{ color: 'red' }}>*</span>
                            </label>
                            <InputText id="roleName" name="roleName" placeholder="Enter Role Name" value={formik?.values?.roleName} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                        </div>
                    </div>

                    <div className="col-12 md:col-12">
                        {allPermissions?.map((module) => {
                            const modulePermissionIds = module.permissions.map((p) => p.id);
                            const allSelected = modulePermissionIds.every((id) => selectedPermissionIds.some((p) => p.modulePermissionId === id));

                            return (
                                <div key={module.moduleId} className="mb-4  border-300 pb-3">
                                    <div className="flex align-items-center gap-3 mb-2">
                                        <label className="flex align-items-center m-0">
                                            <input type="checkbox" checked={allSelected} />
                                        </label>
                                        <p className="text-xl font-semibold m-0">{module.moduleName}</p>
                                    </div>
                                    <div className="pl-4">
                                        {module.permissions.map((permission) => (
                                            <div key={permission.id}>
                                                <label className="flex align-items-center gap-2">
                                                    <input type="checkbox" value={permission.id} checked={selectedPermissionIds.some((p) => p.modulePermissionId === permission.id)} readOnly />
                                                    <span>{permission.permissionName}</span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="flex justify-content-center mt-4 gap-2">
                    <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120 }} onClick={handleCancel} />
                </div>
            </form>
        </div>
    );
};

export default ViewRole;
